/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DynamicPermission } from './DynamicPermission';
import {
    DynamicPermissionFromJSON,
    DynamicPermissionFromJSONTyped,
    DynamicPermissionToJSON,
    DynamicPermissionToJSONTyped,
} from './DynamicPermission';

/**
 * 
 * @export
 * @interface FindAllUserDynamicPermissions200Response
 */
export interface FindAllUserDynamicPermissions200Response {
    /**
     * 
     */
    data?: Array<DynamicPermission>;
}

/**
 * Check if a given object implements the FindAllUserDynamicPermissions200Response interface.
 */
export function instanceOfFindAllUserDynamicPermissions200Response(value: object): value is FindAllUserDynamicPermissions200Response {
    return true;
}

export function FindAllUserDynamicPermissions200ResponseFromJSON(json: any): FindAllUserDynamicPermissions200Response {
    return FindAllUserDynamicPermissions200ResponseFromJSONTyped(json, false);
}

export function FindAllUserDynamicPermissions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllUserDynamicPermissions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(DynamicPermissionFromJSON)),
    };
}

export function FindAllUserDynamicPermissions200ResponseToJSON(json: any): FindAllUserDynamicPermissions200Response {
    return FindAllUserDynamicPermissions200ResponseToJSONTyped(json, false);
}

export function FindAllUserDynamicPermissions200ResponseToJSONTyped(value?: FindAllUserDynamicPermissions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(DynamicPermissionToJSON)),
    };
}

